import DetectionTrendChart from '~/components/guardian/DetectionTrendChart'
import ReactController from '~/controllers/react_controller'

export default class CrowdstrikeDetectionTrendChartController extends ReactController {
  static values = {
    accountIds: Array,
    guardianTiers: Array,
    url: String,
  }

  createComponent() {
    const params = {
      query: {
        account_ids: this.accountIdsValue,
        guardian_tiers: this.guardianTiersValue,
      },
    }

    return <DetectionTrendChart url={this.urlValue} params={params} />
  }
}
